module.exports = __webpack_public_path__ + "img/df.acd0841e.png";